module.exports = __webpack_public_path__ + "img/12_50.17e27b15.png";